import i18n from '@/utils/i18n';
import React from 'react';
import { ListItem } from '@/components/list-item';
import { StyleProp, ViewStyle } from 'react-native';
import { Switch, Props as SwitchProps } from '@/components/switch';

type Props = SwitchProps & {
  listItemStyle?: StyleProp<ViewStyle>;
};

export const ShowPaymentsTabToggleRow: React.FC<Props> = ({
  listItemStyle,
  ...switchProps
}) => {
  return (
    <ListItem
      item={{
        title: i18n.t('show_app_payments_tab_toggle'),
        value: 'show-payments-tab-toggle',
      }}
      listItemStyle={listItemStyle}
      renderRightComponent={() => {
        return <Switch {...switchProps} />;
      }}
    />
  );
};
